import React, { useMemo } from "react";
import { Card, Typography } from "antd";
import styled from "styled-components";
import color from "utils/constants/color";
import OverAllGraph from "./OverAllGraph";
import { getLevelsByConfig, useExamLevelConfig } from "store/placement_exam/selectors";

const { Title, Text } = Typography;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  flex-wrap: wrap;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const ChartContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0;
  width: 100%;
  max-width: 500px;
`;

const LegendContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) => props.color};
  border: 2px solid ${color.indigo100};
  border-radius: 8px;
  padding: 8px;
  margin-bottom: 12px;
  color: white;
  font-weight: bold;
`;

const StyledCard = styled(Card)`
  background-color: #f5f5ff;
  border-radius: 16px;
  padding: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

const getLevels = (max_marks) => {
  const nativos1_end = Math.floor(max_marks * 0.2727);
  const nativos2_end = nativos1_end + Math.floor(max_marks * 0.3636);
  const nativos3_end = nativos2_end + Math.floor(max_marks * 0.2727);
  const ap_end = max_marks; // Remainder goes to AP Spanish

  return [
    {
      legend: `Nativos 1 (0–${nativos1_end} puntos): El estudiante muestra un conocimiento inicial o limitado del español. Necesita apoyo intensivo para mejorar su fluidez y comprensión básica.`,
      color: "#003366",
      range: [0, nativos1_end]
    },
    {
      legend: `Nativos 2 (${nativos1_end + 1}–${nativos2_end} puntos): El estudiante tiene una comprensión moderada y puede comunicarse con limitaciones. La instrucción dirigida y práctica continua son claves.`,
      color: "#f58d1d",
      range: [nativos1_end + 1, nativos2_end]
    },
    {
      legend: `Nativos 3 (${nativos2_end + 1}–${nativos3_end} puntos): El estudiante maneja el idioma con buena fluidez y pocas restricciones. Puede beneficiarse de enseñanza en aspectos complejos.`,
      color: "#40a9ff",
      range: [nativos2_end + 1, nativos3_end]
    },
    {
      legend: `AP Spanish (${nativos3_end + 1}–${ap_end} puntos): El estudiante demuestra un dominio avanzado del español, apto para desafíos lingüísticos y discusiones académicas complejas.`,
      color: "#a084ca",
      range: [nativos3_end + 1, ap_end]
    }
  ];
};
// const CHART_LEVEL = ['Nativos 1','Nativos 2','Nativos 3','AP Spanish']
// const getChartData = (levels) => {
//   return levels.map((level,i) => ({
//     name: `${CHART_LEVEL[i]}: (${level.range[0]}-${level.range[1]})`,
//     y: level.range[1] - level.range[0],
//     color: level.color,
//   }));
// };

const StudentLevelUI = ({ student_marks, max_marks , overAllData , active_exam }) => {
  const exam_levels = useExamLevelConfig(active_exam)
  const levels =  useMemo(()=> getLevelsByConfig(max_marks,exam_levels), [max_marks,exam_levels]);
  const level_suggested = useMemo(()=>{
    try{
      const student_level = levels.find(level => student_marks >= level.range[0] && student_marks <= level.range[1])?.legend.split(':')[0] || 'Unknown'
      return student_level
    } catch (error) {
      console.error(error, "error in level_suggested",levels)
      return 'Unknown'
    }
  }, [student_marks,levels]);

  
  return (
    <StyledCard>
      <Title level={4}>Student Point Overall: {student_marks}</Title>
      <Text strong>Level Suggested: {level_suggested}</Text>

      <Container>
        <OverAllGraph overAllData={overAllData}  is_student_data={true}/>
      </Container>
    </StyledCard>
  );
};

export default StudentLevelUI;
